import { GallerySceneType } from '../CommonTypes';
import { PanoramaZoomableImage } from './PanoramaZoomableImage';

type Props = {
  currentScene: GallerySceneType;
  yaw: number;
  pitch: number; // degrees
  fov: number; // HORIZONTAL FOV in degrees
  aspect: number; // viewer aspect (unused if fov is already horizontal, but handy if you swap to vertical later)
};

const deg2rad = (d: number) => (d * Math.PI) / 180;
const clamp = (v: number, min: number, max: number) => Math.min(max, Math.max(min, v));

export const PanoramaOverviewPicture = ({ currentScene, yaw, pitch, fov }: Props) => {
  // Mini map coordinate system
  const apexX = 50;
  const apexY = 50;

  // Length of the cone responds subtly to pitch (looking up/down shortens it)
  const pitchScale = Math.cos(deg2rad(clamp(Math.abs(pitch), 0, 89)));
  const coneLen = 25 + 15 * pitchScale;

  // Physics-based width
  const hFov = clamp(fov || 75, 10, 160);
  let baseHalf = Math.tan(deg2rad(hFov / 2)) * coneLen;

  // Looser guardrails
  baseHalf = clamp(baseHalf, 1, 70);

  const baseY = apexY + coneLen;
  const leftX = apexX - baseHalf;
  const rightX = apexX + baseHalf;
  const polygonPoints = `${apexX},${apexY} ${leftX},${baseY} ${rightX},${baseY}`;

  return (
    <div className="z-2 absolute right-3 top-3 h-36 w-36 rounded bg-white/80 p-2 sm:h-64 sm:w-64">
      <div className="relative flex h-full w-full items-center justify-center">
        <PanoramaZoomableImage src={currentScene.floorplanpicture} alt="PanoramaImage">
          <svg
            className="absolute"
            style={{
              left: `calc(50% + ${currentScene.posx}%)`,
              top: `calc(50% + ${currentScene.posy}%)`,
              transform: `translate(-50%, -50%) rotate(${-yaw + currentScene.yawoffset}deg)`,
              width: '60px',
              height: '60px',
            }}
            viewBox="0 0 100 100"
          >
            <polygon points={polygonPoints} fill="rgba(0, 150, 95, 0.6)" />
            <circle cx={apexX} cy={apexY} r="5" fill="rgba(0, 150, 95, 0.6)" />
            <line
              x1={apexX}
              y1={apexY}
              x2={apexX}
              y2={baseY}
              stroke="rgba(0,150,95,0.6)"
              strokeWidth="1"
              strokeDasharray="2 2"
            />
          </svg>
        </PanoramaZoomableImage>
      </div>
    </div>
  );
};
